import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.SoundsBinary.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.SoundsBinary.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.answers = [];
  this.soundButton = null;
};

EDC.Games.SoundsBinary.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.SoundsBinary.Scenes.Main.prototype.constructor = EDC.Games.SoundsBinary.Scenes.Main;

const SB = EDC.Games.SoundsBinary.Scenes.Main.prototype;

SB.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

SB.loadIteration = function () {
  this.createButtons();
};

SB.createButtons = function () {
  let correctAnswer;
  const { assetIndex } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const { wrongAnswer } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const font = {
    font: `160px ${this.gameConfig.font}`,
  };
  // create first button
  const container1 = this.add.container(700, 870);
  const button1 = this.add.sprite(0, 0, 'button-1');
  const text1 = this.add.text(260, -610, this.gameConfig.assets[assetIndex[0]].text, font);
  container1.add(button1);
  container1.add(text1);
  container1.setSize(button1.displayWidth, button1.displayHeight);
  this.startShakeAnimation(container1.first);
  container1.setInteractive();
  const markAnim1 = new AnswerMark(this, container1).setScale(0.45);
  container1.setData('markAnim', markAnim1);
  this.cursorManager.setDefaultDraggableEvents(container1);
  container1.on('pointerup', this.checkAnswer.bind(this, container1), this);
  // create second button
  const container2 = this.add.container(1540, 890);
  const button2 = this.add.sprite(0, 0, 'button-2');
  const text2 = this.add.text(-160, -630, this.gameConfig.assets[assetIndex[1]].text, font);
  container2.add(button2);
  container2.add(text2);
  container2.setSize(button2.displayWidth, button2.displayHeight);
  this.startShakeAnimation(container2.first);
  container2.setInteractive();
  const markAnim2 = new AnswerMark(this, container2).setScale(0.45);
  container2.setData('markAnim', markAnim2);
  this.cursorManager.setDefaultDraggableEvents(container2);
  container2.on('pointerup', this.checkAnswer.bind(this, container2), this);

  if (assetIndex[0] === wrongAnswer) {
    container1.isCorrect = false;
    container2.isCorrect = true;
    correctAnswer = assetIndex[1];
  } else {
    container1.isCorrect = true;
    container2.isCorrect = false;
    correctAnswer = assetIndex[0];
  }
  const soundButton = this.add.sprite(1120, 880, 'button-sound');
  soundButton.setInteractive();
  this.cursorManager.setDefaultDraggableEvents(soundButton);
  soundButton.on('pointerup', this.playSound.bind(this, correctAnswer), this);
  this.scaleAnimation(soundButton);

  this.answers.push(container1);
  this.answers.push(container2);
  this.soundButton = soundButton;
};

SB.playSound = function (correctAnswer) {
  const musicArray = this.sound.getAll();
  for (let i = 0; i < musicArray.length; i++) {
    musicArray[i].setVolume(0.1);
  }
  const music = this.sound.add(`sound-${correctAnswer}`);
  music.play();
  music.once(
    'complete',
    function (music) {
      const musicArray = this.sound.getAll();
      for (let i = 0; i < musicArray.length; i++) {
        musicArray[i].setVolume(1);
      }
      music.destroy();
    },
    this,
  );
};

SB.scaleAnimation = function (sprite, delay) {
  let randomDelay = delay;
  if (!delay) {
    randomDelay = 300;
  }
  this.tweens.add({
    targets: sprite,
    scaleX: 1.1,
    scaleY: 1.1,
    duration: 400,
    ease: 'Sine.easeInOut',
    delay: randomDelay,
    yoyo: true,
    onComplete: this.scaleAnimation.bind(this, sprite, 6000 + Math.floor(Math.random() * 3000)),
  });
};

SB.backToStart = function (choice) {
  choice.shakeAnim = this.tweens.add({
    targets: choice,
    angle: 0,
    duration: 100,
    ease: 'Sine.easeInOut',
    yoyo: false,
    onComplete: this.startShakeAnimation.bind(this, choice),
  });
};

SB.startShakeAnimation = function (choice) {
  const repeats = 5;
  choice.shakeAnim = this.tweens.add({
    targets: choice,
    angle: 0,
    duration: 1,
    ease: 'Linear',
    yoyo: false,
    delay: 6000,
    onActive: this.moveRight.bind(this, choice, repeats),
  });
};

SB.moveRight = function (choice, repeats) {
  repeats--;
  if (repeats < 0) {
    this.backToStart(choice);
  } else {
    choice.shakeAnim = this.tweens.add({
      targets: choice,
      angle: 2,
      duration: 100,
      ease: 'Sine.easeInOut',
      yoyo: false,
      onComplete: this.moveLeft.bind(this, choice, repeats),
    });
  }
};

SB.moveLeft = function (choice, repeats) {
  choice.shakeAnim = this.tweens.add({
    targets: choice,
    angle: -2,
    duration: 100,
    ease: 'Sine.easeInOut',
    yoyo: false,
    onComplete: this.moveRight.bind(this, choice, repeats),
  });
};

SB.checkAnswer = function (answer) {
  if (answer.isCorrect) {
    this.playCorrect();
    this.answers.map((x) => {
      x.disableInteractive();
      x.first.shakeAnim.stop();
      x.first.angle = 0;
    });
    answer.getData('markAnim').showMark(true, () => {});
    this.time.delayedCall(2000, this.nextIteration, [], this);
  } else {
    this.playWrong();
    answer.first.setTint(0xff0000);
    answer.first.shakeAnim.stop();
    answer.first.angle = 0;
    answer.disableInteractive();
    answer.getData('markAnim').showMark(false, () => {});
  }
};

SB.nextIteration = function () {
  this.answers.map((x) => {
    x.destroy();
  });
  this.answers = [];
  this.soundButton.destroy();
  this.soundButton = null;
  this.iteration++;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.loadIteration();
  }
};

SB.createTemplateUI = function () {
  const pad = this.add.sprite(1110, 620, 'game-pad');
  const title = this.add.sprite(370, 210, 'title');
  const isntructions = this.add.sprite(280, 650, 'instructions');
};

SB.scaleAnimation = function (sprite, delay) {
  let randomDelay = delay;
  if (!delay) {
    randomDelay = 300;
  }
  this.tweens.add({
    targets: sprite,
    scaleX: 1.1,
    scaleY: 1.1,
    duration: 400,
    ease: 'Sine.easeInOut',
    delay: randomDelay,
    yoyo: true,
    onComplete: this.scaleAnimation.bind(this, sprite, 6000 + Math.floor(Math.random() * 3000)),
  });
};

SB.backToStart = function (choice) {
  choice.shakeAnim = this.tweens.add({
    targets: choice,
    angle: 0,
    duration: 100,
    ease: 'Sine.easeInOut',
    yoyo: false,
    onComplete: this.startShakeAnimation.bind(this, choice),
  });
};

SB.startShakeAnimation = function (choice) {
  const repeats = 5;
  choice.shakeAnim = this.tweens.add({
    targets: choice,
    angle: 0,
    duration: 1,
    ease: 'Linear',
    yoyo: false,
    delay: 6000,
    onActive: this.moveRight.bind(this, choice, repeats),
  });
};

SB.moveRight = function (choice, repeats) {
  repeats--;
  if (repeats < 0) {
    this.backToStart(choice);
  } else {
    choice.shakeAnim = this.tweens.add({
      targets: choice,
      angle: 2,
      duration: 100,
      ease: 'Sine.easeInOut',
      yoyo: false,
      onComplete: this.moveLeft.bind(this, choice, repeats),
    });
  }
};

SB.moveLeft = function (choice, repeats) {
  choice.shakeAnim = this.tweens.add({
    targets: choice,
    angle: -2,
    duration: 100,
    ease: 'Sine.easeInOut',
    yoyo: false,
    onComplete: this.moveRight.bind(this, choice, repeats),
  });
};

export default EDC.Games.SoundsBinary.Scenes.Main;
